/**
 * onboardingCompletionModel — EINE reine Funktion, die entscheidet, ob der
 * Onboarding-Wizard beim Verlassen OHNE verbundenen Kanal zuerst eine Erklärung
 * zeigen muss, statt direkt in den (leeren) Kalender zu wechseln.
 *
 * Hintergrund (docs/STRATEGIE_WETTBEWERB.md: "Onboarding-Wizard endet heute vor
 * der Kanalverbindung — größter Früh-Churn-Hebel"; TODO.md 27.08.2026): Sobald
 * der Monatsplan erzeugt war, markierte `StepGenerate.handleGenerate` das
 * Onboarding serverseitig SOFORT als abgeschlossen (`POST
 * /account/onboarding/complete`, `ff_onboarding_done` im localStorage) —
 * unabhängig davon, welchen der beiden danach angebotenen Knöpfe der Nutzer
 * wählte. Der optisch dominante Knopf führt zwar zur Kanalverbindung (seit
 * 25.08.2026 korrekt verdrahtet), aber der kleinere Ausweg ("Meinen Plan
 * ansehen") verließ den Wizard still — der Nutzer landete mit null
 * verbundenen Kanälen im Kalender, und der Wizard erscheint wegen der bereits
 * gesetzten Erledigt-Marker nie wieder.
 *
 * Diese Funktion schließt NICHT den Ausweg (das würde der Im-Zweifel-nie-
 * einsperren-Linie der App widersprechen, siehe App.js-Onboarding-Check),
 * sondern erzwingt eine explizite, informierte Entscheidung: Ist bekannt, dass
 * kein Kanal verbunden ist, wird zuerst ein Hinweis gezeigt; erst ein zweiter,
 * bestätigter Klick verlässt den Wizard trotzdem.
 *
 * Kein React, keine Seiteneffekte — testbar ohne Rendering.
 */

/**
 * @param {boolean|null|undefined} channelsConnected
 *   true/false, wenn der Verbindungsstatus bekannt ist (aus
 *   GET /simple-flow/channels → has_connected_channels); null/undefined, wenn
 *   die Abfrage (noch) nicht abgeschlossen ist oder fehlgeschlagen ist.
 * @param {boolean} alreadyConfirmed
 *   true, wenn der Hinweis bereits gezeigt wurde und der Nutzer trotzdem
 *   weiter wollte.
 * @returns {boolean} true → Hinweis zeigen statt direkt zu verlassen.
 */
export function shouldConfirmChannellessExit(channelsConnected, alreadyConfirmed = false) {
  if (alreadyConfirmed) return false;
  // Fail-open bei unbekanntem Status (null/undefined, z. B. API-Fehler oder
  // Abfrage noch unterwegs): der Nutzer wird nie eingesperrt.
  return channelsConnected === false;
}
